<template>
    <div class="concats-box bgWhite p10">
        <ul>
            <li class="yjfk">
                <router-link to="/home/feedback">&nbsp;</router-link>
                <div class="hover-box font16 textCenter fontWhite">
                    <span></span>
                    意见反馈
                </div>
            </li>
            <li class="gzh">
                <a href="javascript:;"></a>
                <div class="hover-box p10">
                    <span></span>
                    <img src="../assets/images/header_code.png" alt="" class="w100">
                </div>
            </li>
            <!-- <li class="wxkf">
                <a href="javascript:;"></a>
                <div class="hover-box">
                    <span></span>
                </div>
            </li> -->
            <li class="kfrx">
                <a href="javascript:;" @click="copyText"></a>
                <div class="hover-box font16 textCenter fontWhite">
                    <span></span>
                    400 6565 958
                </div>
            </li>
            <li class="up">
                <a href="javascript:;" @click="toTop()"></a>
            </li>
        </ul>
    </div>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'ConcatsControl',
    data () {
        return {}
    },
    mounted () {
        // 初始化内容

    },
    methods: {
        //页面操作
        toTop () {
            if ($('html').scrollTop()) {
                $('html').animate({ scrollTop: 0 }, 1000);
                return false;
            }
            $('body').animate({ scrollTop: 0 }, 1000);
            return false;            
           
        },
        copyText() {
            let phone = document.createElement("input"); 
            phone.setAttribute("value", '400 6565 958'); 
            document.body.appendChild(phone);
            phone.select();
            document.execCommand("Copy");
            document.body.removeChild(phone);
            this.$message('复制成功')
        }
    },
}
</script>

<style scoped>
    .concats-box {
        /* width: 60px; */
        padding-bottom: 0;
        margin-left: 620px;
        position: fixed;
        left: 50%;
        top: 75%;
        z-index: 999;
    }
    .concats-box a { display: block; width: 40px; height: 40px; margin-bottom: 10px; }
    .concats-box a:hover + .hover-box { display: block; }
    .concats-box .yjfk a { background: url('../assets/images/yjfk.png') no-repeat; background-size: 100% 100%; }
    .concats-box .gzh a { background: url('../assets/images/gzh.png') no-repeat; background-size: 100% 100%; }
    .concats-box .wxkf a { background: url('../assets/images/wxkf.png') no-repeat; background-size: 100% 100%; }
    .concats-box .kfrx a { background: url('../assets/images/kfrx.png') no-repeat; background-size: 100% 100%; }
    .concats-box .up a { background: url('../assets/images/up.png') no-repeat; background-size: 100% 100%; }
    .concats-box .yjfk a:hover { background: url('../assets/images/yjfk_hover.png') no-repeat; background-size: 100% 100%; }
    .concats-box .gzh a:hover { background: url('../assets/images/gzh_hover.png') no-repeat; background-size: 100% 100%; }
    .concats-box .wxkf a:hover { background: url('../assets/images/wxkf_hover.png') no-repeat; background-size: 100% 100%; }
    .concats-box .kfrx a:hover { background: url('../assets/images/kfrx_hover.png') no-repeat; background-size: 100% 100%; }
    .concats-box .up a:hover { background: url('../assets/images/up_hover.png') no-repeat; background-size: 100% 100%; }

    .hover-box { position: absolute; left: -163px; top: 0; z-index: 2; width: 130px; height: 130px; background: #a30000; border: 1px solid #ececec; border-radius: 5px; display: none; }
    .hover-box span { position: absolute; top: 25px; left: 144px; z-index: -1; width: 12px; height: 12px; border-bottom: 1px solid #ececec; border-right: 1px solid #ececec; transform: rotate(-45deg); background: #a30000 }
    .yjfk .hover-box { top: 8px; height: 40px; line-height: 40px; letter-spacing: 5px; left: -144px;}
    .yjfk .hover-box span { top: 16px; left: 124px; }
    .gzh .hover-box { top: 20px; }
    .gzh .hover-box span { top: 50px; }
    .wxkf .hover-box { top: 90px; }
    .wxkf .hover-box span { top: 32px; }
    .kfrx .hover-box { top: 105px; height: 40px; line-height: 40px;  left: -144px; }
    .kfrx .hover-box span { top: 16px; left: 124px; }
</style>